import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function GoogleAdsModal({ isOpen, onClose }) {
  const [inputs, setInputs] = useState({
    headline: '',
    description: ''
  });
  
  const [adContent, setAdContent] = useState({
    headline: 'احتفل بالمحاربين اليوم',
    description: 'يأتي الآن فترة محدودة OFF% خصم يوم المحاربين القدامى 25% استخدم الرمز 25'
  });

  const handleGenerate = () => {
    setAdContent({
      headline: inputs.headline || 'احتفل بالمحاربين اليوم',
      description: inputs.description || 'يأتي الآن فترة محدودة OFF% خصم يوم المحاربين القدامى 25% استخدم الرمز 25'
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleGenerate();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl sm:p-6">
                <div className="absolute right-0 top-0 pr-4 pt-4">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>

                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                    <Dialog.Title as="h3" className="text-xl font-semibold leading-6 text-gray-900 mb-4">
                      Add Headline Caption To Google Ad
                    </Dialog.Title>
                    
                    <div className="bg-gray-50 p-6 rounded-lg mb-6">
                      <div className="flex flex-col items-start p-4 bg-white border border-gray-200 rounded-lg" dir="rtl">
                        <div className="text-sm text-gray-500 mb-2">Sponsored</div>
                        <div className="text-sm text-gray-600 mb-1">rinawi-food-inc.myshopify.com</div>
                        <h2 className="text-lg font-bold text-gray-900 mb-2">{adContent.headline}</h2>
                        <p className="text-gray-600">{adContent.description}</p>
                      </div>
                    </div>

                    <div className="space-y-4">
                      <div>
                        <label htmlFor="headline" className="block text-sm font-medium text-gray-700 mb-1">
                          Ad Headline
                        </label>
                        <div className="flex items-center space-x-4">
                          <input
                            type="text"
                            id="headline"
                            name="headline"
                            value={inputs.headline}
                            onChange={handleInputChange}
                            onKeyPress={handleKeyPress}
                            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                            placeholder="Enter ad headline..."
                          />
                        </div>
                      </div>

                      <div>
                        <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
                          Ad Description
                        </label>
                        <div className="flex items-center space-x-4">
                          <input
                            type="text"
                            id="description"
                            name="description"
                            value={inputs.description}
                            onChange={handleInputChange}
                            onKeyPress={handleKeyPress}
                            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                            placeholder="Enter ad description..."
                          />
                        </div>
                      </div>

                      <div className="flex justify-end">
                        <button
                          onClick={handleGenerate}
                          className="px-4 py-2 bg-[#0049ac] text-white rounded-lg hover:bg-[#0049ac]/90"
                        >
                          Generate
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}